import type { FC, SetStateAction } from "react";

import { Button } from "@/components/ui/button";
import { DialogFooter } from "@/components/ui/dialog";

type SubmitModalFooterProps = {
  setOpen: React.Dispatch<SetStateAction<boolean>>;
  handleSubmit?: () => Promise<void>;
  onClick?: () => void;
  submitLabel?: string;
  isSubmitPending?: boolean;
};

const SubmitModalFooter: FC<SubmitModalFooterProps> = ({
  setOpen,
  handleSubmit,
  onClick = () => {},
  submitLabel = "Générer",
  isSubmitPending = false,
}) => {
  return (
    <DialogFooter className="flex gap-3 px-6">
      <Button
        type="button"
        className="w-full"
        onClick={() => {
          setOpen(false);
        }}
        variant={"outline"}
      >
        Annuler
      </Button>
      <Button
        type="submit"
        className="w-full"
        variant={"blue"}
        onClick={() => {
          if (handleSubmit) {
            handleSubmit();
          } else {
            onClick();
          }
        }}
        loading={isSubmitPending}
      >
        {submitLabel}
      </Button>
    </DialogFooter>
  );
};

export default SubmitModalFooter;
